import { render } from "./logo-ovo.svg?vue&type=template&id=0e3db5de"
const script = {}
script.render = render

export default script